import {Storehouse} from "../../data/data-class/storeHouse/storeHouseClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class StoreHouseRepository {
    static async getStoreHouse(text, pageNumber, add) {
        const data = {
            text: text.trim(),
            pagenumber: pageNumber,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        let storeHouseObject = null
        let countAll = 0
        if (response.success) {
            storeHouseObject = response.data.StoreHouse.map(
                (storehouse) =>
                    new Storehouse(
                        storehouse.serialNumber.trim(),
                        storehouse.deviceName.trim(),
                        storehouse.creator.trim(),
                        storehouse.datepublish.trim(),
                        storehouse.password.trim(),
                        storehouse.id.trim(),
                        storehouse.pin.trim()
                    )
            );
            countAll = response.data.countAll;
        }

        return {
            StoreHouseList: storeHouseObject,
            countAllPages: countAll,
            code,
            massage,
        };
    }

    static async add(add) {
        // const deviceid = await postRequestWithToken("/store-house/add", add);
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/add", add)
            });

    }

    static async delete(id) {
        const data = {
            id: id,
        };
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/delete", data)
            });

    }

    static async sendpass(data) {

        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/change-password", data)
            });

    }

    static async granti(text) {
        const data = {
            text: text,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/search-garanty", data)
            });
        const code = response.statusCode;
        const message = response.message;
        let num = undefined
        if (!response.success) {
            return {
                code,
                message
            }
        }


        return {
            granti: response.data.granti,
            code,
            message,
        };
    }

    static async order(text) {
        const data = {
            text: text,
        };
        // const val = await postRequestWithToken("/store-house/search-order", data);
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/search-order", data)
            });
        const code = response.statusCode;
        const message = response.message;
        let ord = undefined
        if (response.success) {
            ord = response.data.order;
        }

        return {
            order: ord,
            code,
            message,
        };
    }

    static async model(text) {
        const data = {
            text: text,
        };
        // const val = await postRequestWithToken("/store-house/search-model", data);
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/search-model", data)
            });
        const code = response.statusCode;
        const message = response.message;
        if (!response.success) {
            return {
                code,
                message
            }
        }
        return {
            model: response.data.model,
            code,
            message,
        };


    }

    static async donactive(modalinfo) {
        const data = {
            active: modalinfo,
        };
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/store-house/active-serialNumber", data)
            });

    }

    static async scan(data) {
        /*NEVER USED SCAN */
        // await axiosDownloadFile(
        //     "/store-house/get-label/" + data.serialNumber,
        //     "my-file.png"
        // );
        // const  url = val.data
        // const code = val.status.code;
        //  const message = val.status.message;
        // return{
        //  code,
        //  message,
        //  url
        // }
    }
}

export {StoreHouseRepository};
